import React from "react";
import {
  Box,
  Typography,
  Grid,
  CircularProgress,
  Divider,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import RoomSharingCard from "app/components/commonComponents/RoomSharing/room-sharing";
import SearchComponent from "app/components/commonComponents/SearchComponent";
import UseRoomSharingLogic from "app/views/logic/RoomSharing/roomSharingLogic";
import { BackIcon } from "../../../components/commonComponents/icons/EventsIcon";
import { Select, MenuItem } from "@mui/material";
import { formatLabel } from "app/views/commons/commons";

const RoomSharingUI = () => {
  const location = useLocation();
  const eventId = location.state?.id;

  const {
    data,
    loading,
    searchText,
    setSearchText,
    handleNavigate,
    initialLoad,
    hotelOptions,
    selectedHotel,
    setSelectedHotel,
  } = UseRoomSharingLogic(eventId);

  return (
    <Box p={4}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: 2,
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <BackIcon onClick={handleNavigate} sx={{ cursor: "pointer" }} />

          <Typography
            sx={{ color: "#7D49FE", fontSize: "18px", fontWeight: 600 }}
          >
            Room Sharing Users
          </Typography>
        </Box>
        <SearchComponent
          searchTerm={searchText}
          onSearchChange={(e) => setSearchText(e.target.value)}
          onClearSearch={() => setSearchText("")}
        />
        {hotelOptions.length > 1 && (
          <Select
            value={selectedHotel}
            onChange={(e) => setSelectedHotel(e.target.value)}
            displayEmpty
            size="small"
          >
            <MenuItem value="">All Hotels</MenuItem>
            {hotelOptions.map((hotel, index) => (
              <MenuItem key={index} value={hotel}>
                {hotel}
              </MenuItem>
            ))}
          </Select>
        )}
      </Box>

      {initialLoad || loading ? (
        <CircularProgress />
      ) : data.length === 0 ? (
        <Typography sx={{ mt: 2 }}>No room sharing data available</Typography>
      ) : (
        data.map((section, index) => (
          <React.Fragment key={index}>
            <Box p={1}>
              <Typography variant="subtitle1" fontWeight={600} mb={2}>
                {`${section.hotel_name} - ${section.room_type} (${formatLabel(section.sharing_type)} Sharing)`}
              </Typography>

              <Grid container spacing={2}>
                {section.rooms.map((room, i) => (
                  <Grid item xs={12} sm={6} md={3} key={i}>
                    <RoomSharingCard users={room.users} label={room.label} />
                  </Grid>
                ))}
              </Grid>
            </Box>
            {index !== data.length - 1 && <Divider sx={{ my: 2 }} />}
          </React.Fragment>
        ))
      )}
    </Box>
  );
};

export default RoomSharingUI;
